import {isFeatureEnabled} from 'feature-flags';
import {match} from 'ts-pattern';

import {featureFlags} from '@dms/feature-flags';

import {SourcingType} from '../../../../../hooks/useSourcingType';
import {FiltersType} from '../../../types/FiltersType';
import {areVanDimensionFiltersVisible} from '../../../utils/areVanDimensionFiltersVisible';
import {FilterFieldName} from './getFilterSections';

export const isFilterAvailable = (
  field: FilterFieldName,
  filters: FiltersType,
  source: SourcingType
) =>
  match(field)
    .with('auctionType', 'carStatus', 'auctionServer', () => source === SourcingType.AUCTIONS)
    .with(
      'sellerServer',
      'sellerType',
      'avgNumberAds',
      'address',
      'radius',
      'daysOnDisplay',
      () => source === SourcingType.CLASSIFIEDS
    )
    .with(
      'originCountry',
      () =>
        source === SourcingType.CLASSIFIEDS &&
        isFeatureEnabled(featureFlags.SOURCING_ORIGIN_COUNTRY_FILTER)
    )
    .with(
      'vehicleCategory',
      () =>
        source === SourcingType.CLASSIFIEDS && isFeatureEnabled(featureFlags.SOURCING_VAN_FILTERS)
    )
    .with('vehicleLengthCategory', 'vehicleHeightCategory', () =>
      areVanDimensionFiltersVisible(
        filters.vehicleCategory,
        source,
        isFeatureEnabled(featureFlags.SOURCING_VAN_FILTERS)
      )
    )
    .with('interiorMaterial', () =>
      isFeatureEnabled(featureFlags.SOURCING_INTERIOR_MATERIAL_FILTER)
    )
    .with('pricePosition', () => isFeatureEnabled(featureFlags.SOURCING_FILTER_POSITION))
    .with('hideSuspicious', () => isFeatureEnabled(featureFlags.SOURCING_SUSPICIOUS_VEHICLES))
    .with('hitlistOnly', 'hideBlacklist', () =>
      isFeatureEnabled(featureFlags.SOURCING_HITLIST_BLACKLIST)
    )
    .otherwise(() => true);
